
import React from 'react';
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '@/components/ui/alert-dialog';
import { Trash2, AlertTriangle, MapPin } from 'lucide-react';

interface DeleteLocationDialogProps {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  onConfirm: () => void;
  locationName: string;
  usedInTrips?: number;
}

export const DeleteLocationDialog: React.FC<DeleteLocationDialogProps> = ({
  isOpen,
  onOpenChange,
  onConfirm,
  locationName,
  usedInTrips = 0,
}) => {
  const isBlocked = usedInTrips > 0;

  return (
    <AlertDialog open={isOpen} onOpenChange={onOpenChange}>
      <AlertDialogContent className="max-w-md">
        <AlertDialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className={`w-10 h-10 rounded-full flex items-center justify-center ${isBlocked ? 'bg-amber-100' : 'bg-red-100'}`}>
              {isBlocked
                ? <MapPin className="w-5 h-5 text-amber-600" />
                : <AlertTriangle className="w-5 h-5 text-red-600" />
              }
            </div>
            <AlertDialogTitle className="text-lg font-semibold text-slate-800">
              {isBlocked ? 'Location In Use' : 'Delete Location'}
            </AlertDialogTitle>
          </div>
          <AlertDialogDescription className="text-slate-600">
            {isBlocked
              ? `"${locationName}" is being used in ${usedInTrips} trip${usedInTrips > 1 ? 's' : ''} and can't be deleted. Remove it from your trip${usedInTrips > 1 ? 's' : ''} first.`
              : `Are you sure you want to delete "${locationName}"? This action cannot be undone.`
            }
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel className="border-slate-300 text-slate-700 hover:bg-slate-50">
            {isBlocked ? 'OK' : 'Cancel'}
          </AlertDialogCancel>
          {!isBlocked && (
            <AlertDialogAction
              onClick={onConfirm}
              className="bg-red-500 hover:bg-red-600 text-white"
            >
              <Trash2 className="w-4 h-4 mr-2" />
              Delete Location
            </AlertDialogAction>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};
